/* eslint-disable import/prefer-default-export */
import { MetricTimeUnit } from 'enums'
import { DateRange } from 'schemas/DateRangeSchema'
import { date } from './dateUtil'

export const getSparklineMetricTimeUnit = (range: DateRange) => {
  if (!range) {
    return MetricTimeUnit.MINUTE
  }
  const diff = range.end! - range.start!
  if (diff >= date.MS_IN_MONTH * 3) {
    return MetricTimeUnit.WEEK
  }
  if (diff >= date.MS_IN_WEEK) {
    return MetricTimeUnit.DAY
  }
  if (diff >= date.MS_IN_DAY) {
    // Keep same behaviour for current last-day
    return MetricTimeUnit.HOUR
  }
  if (diff > date.MS_IN_HOUR) {
    return MetricTimeUnit.QUARTER_HOUR
  }
  return MetricTimeUnit.MINUTE
}
